/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RecordingManualChangesResponseFields } from './RecordingManualChangesResponseFields';
import {
    RecordingManualChangesResponseFieldsFromJSON,
    RecordingManualChangesResponseFieldsFromJSONTyped,
    RecordingManualChangesResponseFieldsToJSON,
} from './RecordingManualChangesResponseFields';

/**
 * 
 * @export
 * @interface RecordingManualChangesResponse
 */
export interface RecordingManualChangesResponse {
    /**
     * 
     * @type {string}
     * @memberof RecordingManualChangesResponse
     */
    recordingId: string;
    /**
     * 
     * @type {string}
     * @memberof RecordingManualChangesResponse
     */
    documentId?: string | null;
    /**
     * 
     * @type {RecordingManualChangesResponseFields}
     * @memberof RecordingManualChangesResponse
     */
    fields: RecordingManualChangesResponseFields;
}

/**
 * Check if a given object implements the RecordingManualChangesResponse interface.
 */
export function instanceOfRecordingManualChangesResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "recordingId" in value;
    isInstance = isInstance && "fields" in value;

    return isInstance;
}

export function RecordingManualChangesResponseFromJSON(json: any): RecordingManualChangesResponse {
    return RecordingManualChangesResponseFromJSONTyped(json, false);
}

export function RecordingManualChangesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordingManualChangesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'recordingId': json['recording_id'],
        'documentId': !exists(json, 'document_id') ? undefined : json['document_id'],
        'fields': RecordingManualChangesResponseFieldsFromJSON(json['fields']),
    };
}

export function RecordingManualChangesResponseToJSON(value?: RecordingManualChangesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'recording_id': value.recordingId,
        'document_id': value.documentId,
        'fields': RecordingManualChangesResponseFieldsToJSON(value.fields),
    };
}

